import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Row, Col, message, Divider, } from 'antd'
// import styles from './Dashboard.module.scss'
import { Typography, Card, Autocomplete, Grid,  TextField} from '@mui/material'
import { BarChartOutlined } from '@mui/icons-material'


export default function ClientSelection(props) {
    const [Clients, setClients] = useState([])
    const [ClientDatasets, setClientDatasets] = useState([])

    useEffect(() => {
        if (props?.Datasets && props?.Datasets?.data && props?.Datasets.data?.length > 0) {
            let ClientData = []
            let DatasetsData = []
            props?.Datasets.data?.map(item=>{
                // write a logic to push unique clients to ClientData
                if(!ClientData.find(i=>i.value===item.althub_client_id)){
                    ClientData.push({ label: item.name, value: item.althub_client_id })
                }
                // push all datasets to DatasetsData
                DatasetsData.push(
                    {label: item.name, value: item.althub_dataset_id,description: item.description,nowcasting: item.nowcasting,frequency:item.frequency,'data_available_from': item.data_available_from,'data_available_to': item.data_available_to, client_id: item.althub_client_id}
                )
            })            
            setClients(ClientData);
            setClientDatasets(DatasetsData);
            props.setSelectedProvider(ClientData[0]);
            props.setSelectedProviderDataset(DatasetsData[0]);
            // setloader(false);
        }
        return () => {}
    },[props.Datasets])


    return(
        <>
            <div  style={{margin: "0px 0px 0px 0px", paddingTop:'0px'}}>
                <Row gutter={[18,10]}>
                    <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16} style={{display:'flex',justifyContent:'flex-start',paddingTop:'15px'}}>
                        <div style={{color:'var(--textPrimary'}}>
                            <div style={{display:'flex',justifyContent:'flex-start',alignItems:'center'}} >
                                <BarChartOutlined style={{fontSize:'30px',paddingBottom:'0px',margin:'0px'}} /> 
                                <Typography variant='h2' >Alternative Data Analytics Dashboard</Typography>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} style={{paddingTop:'0px',zIndex:10}}>
                        <div>
                            <Row gutter={[18,18]}>
                                <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12} style={{zIndex:10, display:'flex',justifyContent:'flex-start', alignItems:'center', alignContent:'center',paddingTop:'15px'}}>
                                    <Autocomplete
                                        className="data-select"
                                        size='small'
                                        disablePortal
                                        id="disable-clearable"
                                        disableClearable
                                        style={{zIndex:100}}
                                        value={props.SelectedProvider}
                                        fullWidth
                                        options={Clients}
                                        renderInput={(params) => <TextField {...params} label='Choose a Provider' />}
                                        onChange={(e,v)=>{
                                            props.setSelectedProvider(v)
                                            props.setSelectedProviderDataset(ClientDatasets.filter(item=>item.client_id===v?.value)[0]);
                                            props.setloader(true)
                                            props.settickerData([])
                                            props.setloadDashboard(true)
                                        }}
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12} style={{zIndex:10, display:'flex',justifyContent:'flex-start', alignItems:'center', alignContent:'center',paddingTop:'15px'}}>
                                    <Autocomplete
                                        className="data-select"
                                        size='small'
                                        disablePortal
                                        id="disable-clearable"
                                        disableClearable
                                        fullWidth
                                        value={props.SelectedProviderDataset}
                                        defaultValue={props.SelectedProviderDataset}
                                        options={ClientDatasets.filter(item=>item.client_id===props.SelectedProvider?.value)}
                                        renderInput={(params) => <TextField {...params} label='Choose a Dataset' />}
                                        onChange={(e,v)=>{
                                            props.setSelectedProviderDataset(v)
                                        }
                                        }
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>  
        </>
    )

}